<script>
export default {};
</script>
<template id="sideimg">
  <v-img
    src="../assets/img.png"
    height="100vh"
    width="100%"
    object-fit="cover"
  ></v-img>
</template>

<style></style>
